// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2V22H2V2H22ZM7.7844 18.1766L10.1766 6.21547L8.21547 5.82324L5.82324 17.7844L7.7844 18.1766ZM18.1766 17.7844L15.7844 5.82324L13.8232 6.21547L16.2155 18.1766L18.1766 17.7844ZM12.9999 9.99994V6.99994H10.9999V9.99994H12.9999ZM12.9999 13.9999V10.9999H10.9999V13.9999H12.9999ZM12.9999 17.9999V14.9999H10.9999V17.9999H12.9999Z"}}]};

const StreetRoad1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'street-road-1-filled',
    ref,
    icon: element,
  },
));

StreetRoad1FilledIcon.displayName = 'StreetRoad1FilledIcon';

export default StreetRoad1FilledIcon;
